import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, ModalFooter } from '@/components/atom';
import styles from './confirmModal.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ConfirmModal extends React.PureComponent {
  static get propTypes() {
    return {
      body: PropTypes.any,
      opened: PropTypes.bool,
      accept: PropTypes.func,
      cancel: PropTypes.func,
      hideConfirmModal: PropTypes.func
    };
  }
  render() {
    const {
      body,
      opened
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      title: "Confirm",
      className: styles.modal,
      onClose: e => this.onCancel(e),
      opened: opened,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.body,
        children: body
      }), /*#__PURE__*/_jsxs(ModalFooter, {
        className: styles.footer,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: e => this.onConfirm(e),
          color: "primary",
          children: "Confirm"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: e => this.onCancel(e),
          children: "Cancel"
        })]
      })]
    });
  }
  onConfirm(e) {
    e.preventDefault();
    const {
      accept,
      hideConfirmModal
    } = this.props;
    accept();
    hideConfirmModal();
  }
  onCancel(e) {
    e.preventDefault();
    const {
      cancel,
      hideConfirmModal
    } = this.props;
    cancel && cancel();
    hideConfirmModal();
  }
}